import React, { useRef, useState } from 'react';
import { COLORS } from '../App';

export default function FileUpload({ onFiles, accept, label, multiple = true }) {
  const inputRef = useRef();
  const [dragOver, setDragOver] = useState(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    const files = Array.from(e.dataTransfer.files);
    if (files.length) onFiles(files);
  };

  const handleSelect = (e) => {
    const files = Array.from(e.target.files);
    if (files.length) onFiles(files);
    e.target.value = '';
  };

  return (
    <div
      onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
      onDragLeave={() => setDragOver(false)}
      onDrop={handleDrop}
      onClick={() => inputRef.current.click()}
      style={{
        border: `2px dashed ${dragOver ? COLORS.gold : COLORS.border}`,
        borderRadius: 8,
        padding: 32,
        textAlign: 'center',
        cursor: 'pointer',
        background: dragOver ? COLORS.goldLight + '20' : COLORS.white,
        transition: 'all 0.15s',
      }}
    >
      <input ref={inputRef} type="file" multiple={multiple} accept={accept} onChange={handleSelect} style={{ display: 'none' }} />
      <div style={{ fontSize: 28, marginBottom: 8, color: COLORS.textLight }}>+</div>
      <div style={{ fontSize: 14, color: COLORS.text, fontWeight: 500 }}>{label || 'Drop files here or click to browse'}</div>
      <div style={{ fontSize: 12, color: COLORS.textLight, marginTop: 4 }}>PDF, Excel, CSV, Word, Images supported</div>
    </div>
  );
}
